<template>
  <modal
    name="rejectModal"
    :header="$t('functional.rejectEnvelope')"
    :loading="loading">
      <div class="reject-document">
        <p>{{ $t('rejectDocument.rejectWarning') }}</p>
        <p>{{ $t('rejectDocument.areYouSure') }}</p>
        <div class="reject-document__reason">
          <b>{{ $t('rejectDocument.reason') }}</b>
          <textarea ref="reason"></textarea>
        </div>
      </div>
      <template slot="modalButtons" slot-scope="props">
        <BaseButton
          @click.native="props.close"
          variant="secondary"
        >
          {{ $t('functional.close') }}
        </BaseButton>
        <BaseButton
          @click.native="rejectDocument"
          variant="danger"
          :disabled="loading"
          class="float-right"
        >
          {{ $t('functional.reject') }}
        </BaseButton>
      </template>
  </modal>
</template>

<script>
import { rejectDocument } from '@/store/api'
import BaseButton from '@/components/library/buttons/BaseButton.vue'
import Modal from '@/components/Modal'

export default {
  name: 'reject-document',
  components: {
    Modal,
    BaseButton
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    rejectDocument () {
      if (window.IS_PREVIEW) {
        alert(this.$t('rejectDocument.previewWarning'))
      } else {
        const rejectionVal = this.$refs.reason ? this.$refs.reason.value : ''
        this.loading = true
        if (rejectionVal.length > 1) {
          rejectDocument({ store: this.$store, reason: rejectionVal })
            .then(() => {
              this.$bus.$emit('submitEnvelope', {
                response: {
                  status: 'rejected'
                }
              })
            })
        } else {
          alert(this.$t('rejectDocument.reasonRequired'))
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .reject-document
    p
      &:first-child
        margin-top: 0
    textarea
      width: 100%
      max-width: 100%
      height: 100px
    b
      display: block
      margin-bottom: $spacing-small
</style>
